// HomeMainPage.js
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Alert, Snackbar, Box, Slide } from "@mui/material";
import { GlobalContext } from "./context/GlobalContext";
import PublicRoute from "./routing/PublicRoute";
import AdminRoute from "./routing/AdminRoute";
import AgentRoute from "./routing/AgentRoute";
import UserRoute from "./routing/UserRoute";
import { TranslateContext } from "./context/TranslateContext";
import axios from "axios";
import FrontEnd from "./frontend/FrontEnd";
import AdminLogin from "./admin/login/AdminLogin";
import LoadingComp from "./LoadingComp";
import AdminDashboard from "./admin/dashboard/AdminDashboard";
import UserLogin from "./user/login/UserLogin";
import UserPanel from "./user/dashboard/UserPanel";

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

const HomeMainPage = () => {
  const GLOBAL_CONTEXT = React.useContext(GlobalContext);
  const LANGUAGE = React.useContext(TranslateContext);

  React.useEffect(() => {
    const code = localStorage.getItem("language");
    if (code) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/web/get-one-translation?code=${code}`,
        )
        .then((res) => {
          if (res.data.notfound) {
            localStorage.removeItem("language");
            alert("Maybe translate file issue.");
            window.location.reload();
            return;
          }
          LANGUAGE.setData({ ...res.data.data });
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/web/get-all-translation-name`,
        )
        .then((lan) => {
          localStorage.setItem(
            "language",
            lan.data.data[0]?.replace(".json", ""),
          );
          axios
            .get(
              `${process.env.REACT_APP_BASE_URL}/api/web/get-one-translation?code=${lan.data.data[0]?.replace(".json", "")}`,
            )
            .then((res) => {
              LANGUAGE.setData({ ...res.data.data });
            })
            .catch((err) => console.log(err));
        });
    }
  }, []);

  return (
    <Box
      sx={{ position: "relative" }}
      color="text.primary"
      minHeight="100vh"
      bgcolor="background.default"
    >
      {GLOBAL_CONTEXT.data.loading && <LoadingComp />}

      {/* ── Snackbar ── */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={GLOBAL_CONTEXT.data.snack}
        autoHideDuration={4000}
        TransitionComponent={SlideTransition}
        sx={{ top: { xs: 12, sm: 20 } }}
      >
        <Alert
          severity={GLOBAL_CONTEXT.data.snack_success ? "success" : "error"}
          variant="standard"
          sx={{
            minWidth: 280,
            maxWidth: 520,
            borderRadius: 2.5,
            fontWeight: 500,
            fontSize: "0.875rem",
            boxShadow: (theme) =>
              `0 8px 32px ${
                theme.palette.mode === "dark"
                  ? "rgba(0,0,0,0.5)"
                  : "rgba(0,0,0,0.12)"
              }`,
          }}
        >
          {GLOBAL_CONTEXT.data.snack_msg}
        </Alert>
      </Snackbar>

      <div
        style={{
          opacity: GLOBAL_CONTEXT.data.loading ? 0.2 : 1,
          pointerEvents: GLOBAL_CONTEXT.data.loading ? "none" : "initial",
          transition: "opacity 0.2s ease",
        }}
      >
        <Switch>
          <PublicRoute path="/" exact component={UserPanel} />
          <PublicRoute path="/admin/login" exact component={AdminLogin} />
          <AdminRoute path="/admin" exact component={AdminDashboard} />
          <PublicRoute path="/user/login" exact component={UserLogin} />
          <UserRoute path="/user" exact component={UserPanel} />
        </Switch>
      </div>
    </Box>
  );
};

export default HomeMainPage;
